module.exports = "<app-inventory [actionName]=\"actionName\" [toRole]=\"toRole\"></app-inventory>"